module.exports = __webpack_public_path__ + "img/rectangle-output.7a805b89.svg";